import React from 'react';
import { Field } from 'redux-form';

// hocs
import CardFilter from '../../../../hocs/CardFilter';

// Validate
import renderField from '../../../../formValidate/renderField';

import Tooltip from '../../../Tooltip';

// Styles
import { Row } from '../../../../styles/align';
import { Wrapper, Label } from '../../../../styles/forms';
import { TitleCards } from '../../../../styles/titles';
import { Colors, TooltipStyle } from './style';

const BookContent = ({ data, onChangeSubmit }) => {
  const {
    dependencias_adicionais_cores,
    tipos_papel_miolo,
    lados_impressao,
  } = data;

  return (
    <>
      <TitleCards>Tipo de Papel do miolo</TitleCards>
      <TooltipStyle>
              <span>Escolha o tipo de papel:</span>
              <Tooltip
                dataId={"tipo_papel_miolo_info"}
                text={`
                <strong>
                  Quais as diferenças entre os tipos de papel ?
                </strong>
                <br />
                <br />
                <p>
                 🟠 O <strong>Couchê Fosco 115g </strong> é um papel revestido, bem lisinho, com acabamento fosco (sem aquele brilho forte). Ele é ótimo quando o miolo tem imagens, ilustrações, fotos e cores, passando uma sensação bem “premium”. Não é tão indicado para quem quer escrever no livro.
                </p>
                <br />
                <p>
                 🟠 O <strong>Offset 75g</strong> é um papel branco, fosco e com toque mais natural, muito usado para livros com bastante texto e materiais mais longos. Ele é basicamente o Sulfite.
                </p>
                <br />
                <p>
                 🟠 O <strong>Offset 90g</strong> é parecido com o Offset 75g, mas mais encorpado e firme ao folhear. Ele funciona muito bem para livros e apostilas com bastante texto, especialmente quando precisa fazer anotações, porque é ótimo para escrever. Além disso, por ser mais grosso, reduz a transparência e passa uma sensação de mais qualidade.
                </p>
                <br />
                <p>
                 🟠 Já o <strong>Pólen 80g</strong> é um papel fosco com tom levemente amarelado, muito comum nos livros de literatura. Esse amarelado costuma trazer mais conforto visual e deixar a leitura mais agradável por mais tempo, cansando menos os olhos. Ele é excelente para romances, contos, poesias e leituras longas. A única atenção é que, se o seu miolo tiver muitas cores a base amarelada pode “aquecer” um pouco as cores.
                </p>
                `}
                size={0.8}
              />
            </TooltipStyle>
      {/* Código comentado por enquanto, para resolver um problema de tipos de impressão da apostila
        Task: https://app.clickup.com/t/86a8v9ndu

      <Colors>
        {dependencias_adicionais_cores ? (
          dependencias_adicionais_cores.length === 2 ? (
            dependencias_adicionais_cores.map((item, i) => {
              return (
                <Wrapper key={i}>
                  <Field
                    name={'dependencias_adicionais_cores'}
                    id={`dependencias_adicionais_cores[${i}]`}
                    type={'radio'}
                    typefield={'radio'}
                    component={renderField}
                    value={`${item.pk_dependencia_atributo}`}
                    onChange={(event, newValue, previousValue, name) =>
                      onChangeSubmit(event, newValue, previousValue, name)
                    }
                  />
                  <Label htmlFor={`dependencias_adicionais_cores[${i}]`}>
                    {item.cor_impressao}
                  </Label>
                </Wrapper>
              );
            })
          ) : (
            <p>{tipos_papel_miolo.cor_impressao}</p>
          )
        ) : (
          ''
        )}
      </Colors> */}
      <Row>
        {tipos_papel_miolo
          ? tipos_papel_miolo.opcoes.map((item, i) => {
            return (
              <Wrapper key={i}>
                <Field
                  name={'tipos_papel_miolo'}
                  id={`tipos_papel_miolo[${i}]`}
                  type={'radio'}
                  typefield={'radio'}
                  component={renderField}
                  value={`${item.pk_dependencia_atributo}`}
                  onChange={(event, newValue, previousValue, name) =>
                    onChangeSubmit(event, newValue, previousValue, name)
                  }
                />
                <Label htmlFor={`tipos_papel_miolo[${i}]`}>
                  {item.texto_dependencia_atributo}
                </Label>
              </Wrapper>
            );
          })
          : ''}
      </Row>
      {lados_impressao && lados_impressao.opcoes.length > 1 ? (
        <>
          <TitleCards>Lados da Impressão do Miolo</TitleCards>
          <Row>
            {lados_impressao.opcoes.map((item, i) => {
              return (
                <Wrapper key={i}>
                  <Field
                    name={'lados_impressao'}
                    id={`lados_impressao[${i}]`}
                    type={'radio'}
                    typefield={'radio'}
                    component={renderField}
                    value={`${item.pk_dependencia_atributo}`}
                    onChange={(event, newValue, previousValue, name) =>
                      onChangeSubmit(event, newValue, previousValue, name)
                    }
                  />
                  <Label htmlFor={`lados_impressao[${i}]`}>
                    {item.texto_dependencia_atributo}
                  </Label>
                </Wrapper>
              );
            })}
          </Row>
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default CardFilter(BookContent);
